export default class FiltersService {
  constructor(gettext, gettextCatalog) {
    'ngInject';

    this.filtersConfig = {
      name: {
        label: gettext('Name'),
        value: '',
        type: 'text',
        match(asset) {
          if (!this.value) return true;

          const val = asset.name || '';

          return val.toLowerCase().includes(this.value.toLowerCase());
        },
        getDescription() {
          return `${gettextCatalog.getString(this.label)}: ${this.value}`;
        },
      },
      make: {
        label: gettext('Make'),
        value: '',
        type: 'text',
        match(asset) {
          if (!this.value) return true;

          const val = asset.make || '';

          return val.toLowerCase().includes(this.value.toLowerCase());
        },
        getDescription() {
          return `${gettextCatalog.getString(this.label)}: ${this.value}`;
        },
      },
      model: {
        label: gettext('Model'),
        value: '',
        type: 'text',
        match(asset) {
          if (!this.value) return true;

          const val = asset.model || '';

          return val.toLowerCase().includes(this.value.toLowerCase());
        },
        getDescription() {
          return `${gettextCatalog.getString(this.label)}: ${this.value}`;
        },
      },
      cat: {
        label: gettext('Cat'),
        value: '',
        type: 'text',
        match(asset) {
          if (!this.value) return true;

          const val = asset.cat || '';

          return val.toLowerCase().includes(this.value.toLowerCase());
        },
        getDescription() {
          return `${gettextCatalog.getString(this.label)}: ${this.value}`;
        },
      },
      class: {
        label: gettext('Class'),
        value: '',
        type: 'text',
        match(asset) {
          if (!this.value) return true;

          const val = asset.class || '';

          return val.toLowerCase().includes(this.value.toLowerCase());
        },
        getDescription() {
          return `${gettextCatalog.getString(this.label)}: ${this.value}`;
        },
      },
      seenIn: {
        label: gettext('Seen In'),
        value: '',
        type: 'select',
        options: [
          {
            key: 'seenIn3d',
            desc: gettext('Seen In 3 Days'),
          },
          {
            key: 'seenIn7d',
            desc: gettext('Seen In 7 Days'),
          },
          {
            key: 'seenIn14d',
            desc: gettext('Seen In 14 Days'),
          },
          {
            key: 'notSeenIn14d',
            desc: gettext('Seen In 14+ Days'),
          },
          {
            key: 'offSite',
            desc: gettext('Off Site'),
          },
        ],
        match(asset) {
          if (!this.value) return true;
          if (this.value === 'offSite') {
            return !asset.onSite;
          }
          return asset.onSite && asset.seenIn === this.value;
        },
        getDescription() {
          if (this.value) {
            return gettextCatalog.getString(
              this.options.find((option) => option.key === this.value).desc,
            );
          }

          return '';
        },
      },
      usedIn: {
        label: gettext('Used In'),
        value: '',
        type: 'select',
        options: [
          {
            key: 'usedIn3d',
            desc: gettext('Used In 3 Days'),
          },
          {
            key: 'notUsedIn3d',
            desc: gettext('Not Used In 3+ Days'),
          },
          {
            key: 'notUsedIn7d',
            desc: gettext('Not Used In 7+ Days'),
          },
          {
            key: 'notUsedIn14d',
            desc: gettext('Not Used In 14+ Days'),
          },
        ],
        match(asset) {
          if (!this.value) return true;

          const val = asset.usedIn || '';

          return val === this.value;
        },
        getDescription() {
          if (this.value) {
            return gettextCatalog.getString(
              this.options.find((option) => option.key === this.value).desc,
            );
          }

          return '';
        },
      },
      assetType: {
        label: gettext('Asset Type'),
        value: '',
        type: 'select',
        options: [
          {
            key: 'Tool',
            desc: gettext('Tool'),
          },
          {
            key: 'Accessory',
            desc: gettext('Accessory'),
          },
          {
            key: 'Material',
            desc: gettext('Material'),
          },
          {
            key: 'Storage',
            desc: gettext('Storage'),
          },
          {
            key: 'Equipment',
            desc: gettext('Equipment'),
          },
          {
            key: 'gateway',
            desc: gettext('Gateway'),
          },
        ],
        match(asset) {
          if (!this.value) return true;

          const val = asset.assetType || '';

          return val.toLowerCase() === this.value.toLowerCase();
        },
        getDescription() {
          return `${gettextCatalog.getString(this.label)}: ${this.value}`;
        },
      },
      onSite: {
        label: gettext('On Site'),
        value: '',
        type: 'select',
        options: [
          {
            key: 'onsite',
            desc: gettext('On Site'),
          },
          {
            key: 'offsite',
            desc: gettext('Off Site'),
          },
        ],
        match(asset) {
          if (this.value) {
            const val = asset.onSite || false;
            return this.value === 'onsite' ? val : !val;
          }
          return true;
        },
        getDescription() {
          if (this.value !== '') {
            return gettextCatalog.getString(
              this.options.find((option) => option.key === this.value).desc,
            );
          }

          return '';
        },
      },
    };
  }

  getDefaultFilters(filterNames = []) {
    const filterIndex = filterNames.reduce((obj, cur, index) => {
      obj[cur] = index;
      return obj;
    }, {});

    const filters = filterNames.map((filterName) => ({ ...this.filtersConfig[filterName] }));

    const getFilterByName = (filterName) => filters[filterIndex[filterName]];

    return [filters, getFilterByName];
  }
}
